<script lang="ts">
    import type {Link} from '../../../typings/portaro.be.types';
    import {resolveTarget, resolveHref} from './link-utils';
    import {pipe} from '../../../svelte/utils';
    import {loc} from '../../../svelte/pipes';

    export let link: Link;

</script>

<template>
    <a href={resolveHref(link)} target={resolveTarget(link)}>
        {pipe(link, loc())}{#if $$slots.note}
            <slot name="note"></slot>
        {/if}
    </a>
</template>

<style lang="less">

</style>